export default __webpack_public_path__ + "static/media/km3.175e5c0b.png";